import { createRouter, createWebHistory } from 'vue-router'

import AuthRoutes from './_auth'
import UserRoutes from './_user'
import EditorRoutes from './_editor'
import PublisherRoutes from './_publisher'
import AdminRoutes from './_admin'
import GuestRoutes from './_guest'

const routes = [
    ...AuthRoutes,
    ...UserRoutes,
    ...EditorRoutes,
    ...PublisherRoutes,
    ...AdminRoutes,
    ...GuestRoutes,

    // Not found
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/Error/NotFound.vue'),
    },
]

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    base: import.meta.env.BASE_URL,
    routes,
})

export default router
